import $ from "jquery";

import Backbone from "backbone";

import DateRangeSelector from "./date_range_selector";

import dateRangeTemplate from "./date_range_selector/date_range_template";
import dateSelections from "./date_range_selector/date_selections";

import Modal from "../modal";

import DateFormatter from "shared/formatters/dates";

import _ from "underscore";

class DateRangeSelectorModal extends Modal {
  initialize({ eventsHash, dateRangeSelector }) {
    this.events = eventsHash;
    this.dateRangeSelector = dateRangeSelector;
  }

  _onUpdate(...args) {
    this.dateRangeSelector._onUpdate.apply(this.dateRangeSelector, args);
  }

  _onDateFilterSelect(...args) {
    this.dateRangeSelector._onDateFilterSelect.apply(this.dateRangeSelector, args);
  }

  _customDate(...args) {
    this.dateRangeSelector._customDate.apply(this.dateRangeSelector, args);
  }
}

_.extend(DateRangeSelectorModal.prototype, {
  title: "Select Date Range",
  className: "date-range-modal",
  body: '<div class="date-range-selector" data-mount="date-range-selector"></div>',

  buttons: [
    {
      text: "Cancel",
      className: "btn-secondary",
      close: true
    },
    {
      text: "Update",
      className: "btn-primary",
      click() {
        const modal = this.parent;
        modal._onUpdate();
        modal.close();
      }
    }
  ]
});

export default class CustomDateRangeSelector extends DateRangeSelector {
  initialize({ reportTimezone, defaultDateFilter }) {
    this.model = new Backbone.Model();
    this.reportTimezone = reportTimezone;
    this.defaultDateFilter = defaultDateFilter || 'last_7days';

    this.modalBody = _.template(dateRangeTemplate({ reportTimezone: this.reportTimezone }));

    const dateHash = this._initParams();

    if (dateHash.dateFilter === 'custom') {
      this._setDates(dateHash);
    } else {
      this._changeDateFilter(dateHash);
    }
    this._replaceState();

    this._getOrCreateModal();
    this._initializeCustomDropDownSelection();
  }

  render() {
    const dateHash = this._buildDateHash();
    this.$el.html(_.template(this.body()));

    this.$('[data-name="date-filter-button-text"]').text(`${dateHash.dateFilterName}:`);
    this.$('[data-name="primary-range-button-text"]').text(DateFormatter.fromDateRange(dateHash.dates, dateHash.dateFilter));

    return this;
  }

  _renderInterior() {
    this._getOrCreateModal().$('[data-mount="date-range-selector"]').empty();
    this._getOrCreateModal().$('[data-mount="date-range-selector"]').append(_.template(`<div class="${this.modalClassName}">${this._buildTemplate()}</div>`));
    this._attachDatePickers();
    this._drawControl();

    return this;
  }

  _dateSelectionFromModel(...args) {
    const value = this.model.get('dateFilter');

    if (value === 'custom') {
      return { value };
    } else {
      return super._dateSelectionFromModel(...args);
    }
  }

  _getOrCreateModal(forceCreate) {
    if (forceCreate && this.child("date-range-selector-modal")) {
      this.child("date-range-selector-modal").close();
      this.child("date-range-selector-modal", undefined);
    }

    if (!this.child("date-range-selector-modal")) {
      this.child("date-range-selector-modal", new DateRangeSelectorModal({
        reportTimezone: this.reportTimezone,
        eventsHash: this.modalEvents,
        dateRangeSelector: this
      }));
    }

    return this.child("date-range-selector-modal");
  }

  _initializeCustomDropDownSelection() {
    // if custom is already there, don't add it!
    if (!_.find(dateSelections, ({ value }) => value === "custom")) {
      dateSelections.push({ value: "custom", label: "Custom" });
    }
  }

  _initParams(...args) {
    const params = $.deparam(window.location.search.substring(1));
    const cookie = $.cookie("pegasus_reports_date_filter");
    let dateHash;

    if (!_.isEmpty(params) && params.date_filter && params.date_filter === 'custom') {
      dateHash = { dateFilter: 'custom', dates: [params.from, params.to] };
    } else if (cookie && cookie.match(/^custom_/)) {
      const cookiedDates = cookie.replace('custom_', '').split('_').map(decodeURIComponent);
      dateHash = { dateFilter: 'custom', dates: cookiedDates };
    } else {
      dateHash = super._initParams(...args);
    }

    return dateHash;
  }

  _getParams(...args) {
    const params = super._getParams(...args);
    const dates = this.model.get('dates');

    if (params.date_filter === 'custom') {
      params.from = dates[0];
      params.to = dates[1];
    }

    return params;
  }

  _changeDatesHandler(dateHash) {
    if (dateHash.dateFilter === 'custom') {
      this._setDates(dateHash);
    } else {
      this._changeDateFilter(dateHash);
    }
  }

  _onDateFilterSelect({ currentTarget }) {
    const newValue = $(currentTarget).data('value');
    if (newValue.match(/^custom/)) {
      this._customDate();
    } else {
      this._changeDateFilter({ dateFilter: newValue });
    }

    const dateHash = this._buildDateHash();
    this._mapDateRange(dateHash);
    this._drawDateFilters();
  }

  _getDateRange(dates, dateFilter) {
    if (dateFilter === 'custom') {
      return ['', ''];
    }

    return super._getDateRange.apply(this, arguments);
  }

  _onButtonClick() {
    const dateHash = this._initParams();
    this.model.set(dateHash);

    const selectorModal = this._getOrCreateModal(true); // force create
    selectorModal.render();
    this._renderInterior(selectorModal);
    return false;
  }

  _onUpdate() {
    const dateHash = this._buildDateHash();

    this._replaceState();
    this.trigger("change", dateHash.dateFilter, dateHash.dates, dateHash);

    this.$('[data-name="date-filter-button-text"]').text(`${dateHash.dateFilterName}:`);
    this.$('[data-name="primary-range-button-text"]').text(DateFormatter.fromDateRange(dateHash.dates, dateHash.dateFilter));

    return dateHash;
  }

  _mapDateRange({ dates, dateFilter }) {
    const modalContext = this._getOrCreateModal();
    if (dates && !_.isEmpty(_.compact(dates))) {
      this.model.set('dates', dates);
      modalContext.$('[data-name="primary-range-start"]').datepicker('update', dates[0]);
      modalContext.$('[data-name="primary-range-end"]').datepicker('update', dates[1]);
    } else {
      this.model.set('dates', false);
    }
    // link datepickers within date range
    modalContext.$('[data-name="primary-range"]').datepicker('updateDates');

    if (dateFilter === "custom") {
      this.model.set("dateFilter", dateFilter);
      this._renderCustomDate(modalContext);
    }

    this._setTargetModalHeader('primary', dates, dateFilter);
  }

  _buildTemplate() {
    return this.modalBody();
  }

  _buildDateHash() {
    const dateSelection = this._dateSelectionFromModel();
    let dateHash;

    if (dateSelection.value === 'custom') {
      dateHash = {
        dates: this.model.get('dates'),
        dateFilter: 'custom',
        dateFilterName: 'Custom'
      };
    } else {
      dateHash = {
        dates: _.map(DateFormatter.dateRange(dateSelection.value), this._dateString),
        dateFilter: dateSelection.value,
        dateFilterName: dateSelection.label
      };
    }

    return dateHash;
  }

  _attachDatePickers() {
    this._getOrCreateModal().$('[data-name="primary-range"]').datepicker({
      format: DateFormatter.localeFormatString('datepicker'),
      inputs: this._getOrCreateModal().$('[data-name="primary-range-start"], [data-name="primary-range-end"]')
    });
  }

  _drawControl() {
    const dateHash = this._buildDateHash();

    this._mapDateRange(dateHash);

    this._drawDateFilters();

    return this;
  }

  _drawDateFilters() {
    this._getOrCreateModal().$('[data-name="date-range-list-container"]').empty();

    _.each(dateSelections, function({ value, label }) {
      const classes = value === this.model.get("dateFilter") ? 'active' : '';
      this.child('date-range-selector-modal').$('[data-name="date-range-list-container"]').append(`<a class="list-group-item list-group-item-action ${classes}" href="#" onClick="return false;" data-value="${value}">${label}</a>`);
    }, this);
  }

  _renderCustomDate() {
    this._getOrCreateModal().$('[data-name="date-range-list-container"] a').removeClass("active");
    this._getOrCreateModal().$('[data-name="date-range-list-container"] a[data-value="custom"]').addClass("active");
  }

  _getDatesFromDatePicker() {
    const dateHash = {
      dates: [
        this._getOrCreateModal().$('[data-name="primary-range-start"]').datepicker('getDate'),
        this._getOrCreateModal().$('[data-name="primary-range-end"]').datepicker('getDate')
      ].map(this._dateString)
    };

    return dateHash;
  }

  _setDates(dateHash) {
    this.model.set(dateHash);

    this.trigger("change:internal", dateHash, this.model.get('compareDatesOn'));
  }

  _customDate() {
    let dateHash = this._getDatesFromDatePicker();
    this._setDates(_.extend({}, dateHash, { dateFilter: 'custom' }));
    this._renderCustomDate();

    dateHash = this._buildDateHash();
    this._setTargetModalHeader('primary', dateHash.dates, dateHash.dateFilter);
  }

  _setTargetModalHeader(targetName, dates, dateFilter) {
    this._getOrCreateModal().$(`[data-name="${targetName}-header"]`).text(DateFormatter.fromDateRange(dates, dateFilter));
  }
}

_.extend(CustomDateRangeSelector.prototype, {
  body: _.template(`
      <button type="button" class="btn btn-default date-range-selector-modal-button" data-name="date-range-selector-button">
        <span class="date-filter-button-text" data-name="date-filter-button-text"></span>
        <span class="primary-range-button-text" data-name="primary-range-button-text"></span>
      </button>`),

  events: {
    "click [data-name='date-range-selector-button']": "_onButtonClick"
  },

  modalEvents: {
    'click [data-name="date-range-list-container"] a': "_onDateFilterSelect",
    'changeDate [data-name="primary-range-start"], [data-name="primary-range-end"]': "_customDate"
  },

  modalClassName: "default-date-range-selector"
});
